import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import  qualityImage  from '../assets/q.png'
import Injections1 from '../assets/Injections1.png'
import infusion1 from '../assets/infusion1.png'
import oncology1 from '../assets/oncology1.png'
import rnd2 from '../assets/image-rnd2.jpg'
import rnd3 from '../assets/image3.png'

const useReveal = (delay = 0) => {
  const ref = useRef(null);
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setTimeout(() => setVis(true), delay); obs.disconnect(); }
    }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, vis];
};

const RND = () => {
  const { t } = useTranslation();

  const [introLeftRef,  introLeftVis]  = useReveal(0);
  const [introRightRef, introRightVis] = useReveal(160);
  const [focusLeftRef,  focusLeftVis]  = useReveal(0);
  const [focusRightRef, focusRightVis] = useReveal(160);
  const [futureLeftRef, futureLeftVis] = useReveal(0);
  const [futureRightRef,futureRightVis]= useReveal(160);

  return (
    <div className="rnd-root">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=Playfair+Display:wght@700;800&display=swap');

        @keyframes rndHeroIn { from{opacity:0;transform:translateY(36px)} to{opacity:1;transform:translateY(0)} }
        @keyframes rndSlideL { from{opacity:0;transform:translateX(-44px)} to{opacity:1;transform:translateX(0)} }
        @keyframes rndSlideR { from{opacity:0;transform:translateX(44px)}  to{opacity:1;transform:translateX(0)} }

        .rnd-root { font-family:'Outfit',sans-serif; }

        /* ══ HERO ══ */
        .rnd-hero {
          position:relative; min-height:300px; display:flex;
          align-items:center; justify-content:center;
          overflow:hidden; padding-top:80px;
          background:linear-gradient(135deg,#0d2233 0%,#1a3a4a 55%,#0f2d3d 100%);
        }
        .rnd-hero-bg {
          position:absolute; inset:0; width:100%; height:100%;
          object-fit:cover; opacity:0.2;
        }
        .rnd-hero-overlay {
          position:absolute; inset:0;
          background:linear-gradient(135deg,rgba(13,34,51,0.72) 0%,rgba(26,58,74,0.65) 100%);
        }
        .rnd-hero-grid {
          position:absolute; inset:0; pointer-events:none;
          background-image:
            linear-gradient(rgba(58,143,163,0.07) 1px,transparent 1px),
            linear-gradient(90deg,rgba(58,143,163,0.07) 1px,transparent 1px);
          background-size:56px 56px;
        }
        .rnd-hero-line {
          position:absolute; top:0; left:0; right:0; height:3px;
          background:linear-gradient(90deg,transparent,#3a8fa3,#5aab9a,#3a8fa3,transparent);
        }
        .rnd-hero-content {
          position:relative; z-index:2; text-align:center;
          padding:70px 24px 64px;
          animation:rndHeroIn 0.85s cubic-bezier(0.4,0,0.2,1) 0.1s both;
        }
        .rnd-hero-eyebrow {
          display:inline-block; font-size:0.72rem; font-weight:600;
          letter-spacing:0.14em; text-transform:uppercase;
          color:#5aab9a; background:rgba(90,171,154,0.12);
          border:1px solid rgba(90,171,154,0.3);
          padding:5px 16px; border-radius:999px; margin-bottom:18px;
        }
        .rnd-hero-title {
          font-family:'Playfair Display',serif;
          font-size:clamp(2.2rem,5vw,4rem); font-weight:800;
          color:#fff; margin:0; line-height:1.15;
          text-shadow:0 2px 32px rgba(0,0,0,0.4);
        }

        /* ══ Shared section bg ══ */
        .rnd-teal   { background:linear-gradient(180deg,#e8f5f7 0%,#d4eef2 60%,#e0f4f7 100%); position:relative; overflow:hidden; }
        .rnd-teal-2 { background:linear-gradient(180deg,#d4eef2 0%,#c8e8ed 100%); position:relative; overflow:hidden; }
        .rnd-dots {
          position:absolute; inset:0; pointer-events:none;
          background-image:radial-gradient(circle,rgba(58,143,163,0.05) 1px,transparent 1px);
          background-size:36px 36px;
        }
        .rnd-blob { position:absolute; border-radius:50%; pointer-events:none; filter:blur(80px); }
        .rnd-blob-tl { width:400px;height:400px;background:rgba(58,143,163,0.08);top:-100px;left:-100px; }
        .rnd-blob-br { width:350px;height:350px;background:rgba(90,171,154,0.07);bottom:-80px;right:-80px; }
        .rnd-inner { max-width:1280px; margin:0 auto; padding:0 32px; position:relative; z-index:1; }

        /* ══ SECTION GRID ══ */
        .rnd-section { padding:90px 0; }
        .rnd-grid-lr {
          display:grid; grid-template-columns:1fr 1fr; gap:70px; align-items:center;
        }
        .rnd-grid-rl {
          display:grid; grid-template-columns:1fr 1fr; gap:70px; align-items:center;
        }
        @media(max-width:900px){
          .rnd-grid-lr,.rnd-grid-rl { grid-template-columns:1fr; }
          .rnd-grid-rl .rnd-img-col { order:-1; }
        }

        /* ══ Slide animations ══ */
        .rnd-slide-l { opacity:0; transform:translateX(-44px); transition:all 0.85s cubic-bezier(0.4,0,0.2,1); }
        .rnd-slide-r { opacity:0; transform:translateX(44px);  transition:all 0.85s cubic-bezier(0.4,0,0.2,1) 0.15s; }
        .rnd-slide-l.in { opacity:1; transform:translateX(0); }
        .rnd-slide-r.in { opacity:1; transform:translateX(0); }

        /* ══ TEXT ══ */
        .rnd-section-title {
          font-family:'Playfair Display',serif;
          font-size:clamp(1.7rem,2.8vw,2.4rem); font-weight:800;
          color:#1a3a4a; margin:0 0 10px; line-height:1.25;
        }
        .rnd-section-sub {
          font-size:1rem; font-weight:600; color:#3a8fa3; margin-bottom:22px; line-height:1.5;
        }
        .rnd-body {
          font-size:0.97rem; color:#3d5a6a; line-height:1.95;
          text-align:justify; margin-bottom:0;
        }

        /* ══ IMAGES ══ */
        /* Intro: two pill-shaped images side by side */
        .rnd-pill-pair {
          display:flex; gap:16px; align-items:flex-end;
        }
        .rnd-pill {
          flex:1; overflow:hidden;
          border:2.5px solid rgba(255,255,255,0.75);
          box-shadow:0 16px 48px rgba(58,143,163,0.18),0 4px 16px rgba(0,0,0,0.08);
          transition:transform 0.4s cubic-bezier(0.4,0,0.2,1),box-shadow 0.4s;
        }
        .rnd-pill:first-child {
          height:320px;
          border-radius:180px 180px 120px 120px;
        }
        .rnd-pill:last-child {
          height:320px;
          border-radius:180px 180px 120px 120px;
        }
        .rnd-pill:hover {
          transform:translateY(-8px);
          box-shadow:0 28px 64px rgba(58,143,163,0.26),0 8px 24px rgba(0,0,0,0.1);
        }
        .rnd-pill img { width:100%;height:100%;object-fit:cover;display:block; }

        /* Focus / Future: standard rounded image */
        .rnd-img-frame {
          border-radius:20px; overflow:hidden;
          box-shadow:0 20px 56px rgba(58,143,163,0.18),0 6px 20px rgba(0,0,0,0.08);
          transition:transform 0.4s cubic-bezier(0.4,0,0.2,1),box-shadow 0.4s;
        }
        .rnd-img-frame:hover {
          transform:translateY(-8px);
          box-shadow:0 32px 72px rgba(58,143,163,0.24),0 10px 28px rgba(0,0,0,0.1);
        }
        .rnd-img-frame img { width:100%;height:320px;object-fit:cover;display:block; }
      `}</style>

      {/* ══ HERO ══ */}
      <section className="rnd-hero">
        <img
          // src="https://nitaaralifesciences.com/assets/rd-BEoUUxqO.webp"
          alt=""
          className="rnd-hero-bg"
          onError={e => { e.target.style.display = 'none'; }}
        />
        <div className="rnd-hero-overlay" />
        <div className="rnd-hero-grid" />
        <div className="rnd-hero-line" />
        <div className="rnd-hero-content">
          <div className="rnd-hero-eyebrow">{t('rdPage.hero.eyebrow')}</div>
          <h1 className="rnd-hero-title">{t('rdPage.hero.title')}</h1>
        </div>
      </section>

      {/* ══ INTRO — text left, pill images right ══ */}
      <section className="rnd-teal rnd-section">
        <div className="rnd-dots" /><div className="rnd-blob rnd-blob-br" />
        <div className="rnd-inner">
          <div className="rnd-grid-lr">
            {/* Text left */}
            <div
              ref={introLeftRef}
              className={`rnd-slide-l ${introLeftVis ? 'in' : ''}`}>
              <h2 className="rnd-section-title">{t('rdPage.intro.title')}</h2>
              <p className="rnd-section-sub">{t('rdPage.intro.subtitle')}</p>
              <p className="rnd-body">{t('rdPage.intro.p1')}</p>
            </div>

            {/* Two pill images right */}
            <div
              ref={introRightRef}
              className={`rnd-slide-r ${introRightVis ? 'in' : ''}`}>
              <div className="rnd-pill-pair">
                <div className="rnd-pill">
                  <img
                    src={qualityImage}
                    alt="R&D Lab"
                    onError={e => { e.target.src = 'https://images.unsplash.com/photo-1576086213369-97a306d36557?w=400&h=500&fit=crop'; }}
                  />
                </div>
                <div className="rnd-pill">
                  <img
                    src={Injections1}
                    alt="R&D Research"
                    onError={e => { e.target.src = 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?w=400&h=400&fit=crop'; }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ FOCUS — image left, text right ══ */}
      <section className="rnd-teal-2 rnd-section">
        <div className="rnd-dots" /><div className="rnd-blob rnd-blob-tl" />
        <div className="rnd-inner">
          <div className="rnd-grid-rl">
            {/* Image left */}
            <div
              ref={focusLeftRef}
              className={`rnd-slide-l rnd-img-col ${focusLeftVis ? 'in' : ''}`}>
              <div className="rnd-img-frame">
                <img
                  src={rnd2}
                  alt="R&D Focus"
                  onError={e => { e.target.src = 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=700&h=400&fit=crop'; }}
                />
              </div>
            </div>

            {/* Text right */}
            <div
              ref={focusRightRef}
              className={`rnd-slide-r ${focusRightVis ? 'in' : ''}`}>
              <h2 className="rnd-section-title">{t('rdPage.focus.title')}</h2>
              <p className="rnd-body" style={{ marginTop: '18px' }}>{t('rdPage.focus.body')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ FUTURE GOALS — text left, image right ══ */}
      <section className="rnd-teal rnd-section">
        <div className="rnd-dots" /><div className="rnd-blob rnd-blob-br" />
        <div className="rnd-inner">
          <div className="rnd-grid-lr">
            {/* Text left */}
            <div
              ref={futureLeftRef}
              className={`rnd-slide-l ${futureLeftVis ? 'in' : ''}`}>
              <h2 className="rnd-section-title">{t('rdPage.future.title')}</h2>
              <p className="rnd-body" style={{ marginTop: '18px' }}>{t('rdPage.future.body')}</p>
            </div>

            {/* Image right */}
            <div
              ref={futureRightRef}
              className={`rnd-slide-r ${futureRightVis ? 'in' : ''}`}>
              <div className="rnd-img-frame">
                <img
                  src={rnd3}
                  alt="Future R&D"
                  onError={e => { e.target.src = 'https://images.unsplash.com/photo-1579154204601-01588f351e67?w=700&h=400&fit=crop'; }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default RND;